var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rabbey-table',{ref:"r",attrs:{"headers":_vm.headers,"actions":_vm.options,"index-url":"/api/CMI/Perpectives/All","callback-index":_vm.handleTable},on:{"push:action":_vm.hanleAction,"get:data":_vm.getdata}})
}
var staticRenderFns = []

export { render, staticRenderFns }